import React from "react";
import { LegalPage } from "../components/LegalPage";

const ADDRESS = "MyCleaner Hofer\nInhaberin: Renata Hofer\nKirchweg 25\n5313 Klingnau, Schweiz\nTelefon: 044 688 03 80\nE-Mail: info@mycleaner.ch";

const SECTIONS = [
  { h: "Anbieter und Geltungsbereich", p: [
    "Diese Allgemeinen Geschäftsbedingungen gelten für die von MyCleaner Hofer angebotenen Reinigungsdienstleistungen in der Schweiz.",
    `Anbieterin:\n${ADDRESS}\nWebsite: www.mycleaner.ch`,
    "Die AGB gelten für einmalige und regelmässige Reinigungsaufträge von Privatkunden sowie für weitere ausdrücklich vereinbarte Dienstleistungen.",
    "Individuelle schriftliche Vereinbarungen gehen diesen AGB vor.",
  ]},
  { h: "Dienstleistungen", p: ["MyCleaner bietet insbesondere folgende Reinigungsarbeiten an:"],
    ul: [
      "Regelmässige Haushaltsreinigung", "Einmalige Wohnungsreinigung", "Reinigung von Küche, Bad und WC",
      "Staubsaugen und Bodenreinigung", "Staubwischen und allgemeines Aufräumen", "Betten beziehen und Wäschearbeiten",
      "Bügelarbeiten", "Innenreinigung von Fenstern, soweit sicher zugänglich", "Weitere individuell vereinbarte Haushaltsarbeiten",
    ],
    p2: [
      "Der konkrete Leistungsumfang ergibt sich aus der bestätigten Buchung oder einer individuellen Vereinbarung.",
      "Spezialreinigungen, gefährliche Arbeiten und Tätigkeiten, die besondere Geräte oder Fachkenntnisse erfordern, sind nur geschuldet, wenn sie ausdrücklich vereinbart wurden.",
    ]},
  { h: "Buchung und Vertragsabschluss", p: [
    "Kunden können über die Website, telefonisch oder per E-Mail eine Reinigungsanfrage stellen.",
    "Die Übermittlung einer Anfrage ist kostenlos und unverbindlich.",
    "Ein verbindlicher Auftrag entsteht erst, wenn MyCleaner die Anfrage mit den wesentlichen Auftragsdaten bestätigt und der Kunde diese bestätigt oder die Parteien den Auftrag anderweitig verbindlich vereinbaren.",
    "MyCleaner kann Anfragen ablehnen, insbesondere wenn keine geeigneten Kapazitäten verfügbar sind.",
  ]},
  { h: "Preise und Abrechnung", p: [
    "Der reguläre Preis für die auf der Website angebotene Haushaltsreinigung beträgt CHF 43.90 pro Stunde.",
    "Der vereinbarte Preis umfasst die reguläre Reinigungsleistung. Optionales Reinigungsmaterial oder ausdrücklich vereinbarte Zusatzleistungen können zusätzlich verrechnet werden, sofern der Kunde vorab über die Kosten informiert wurde und diesen zugestimmt hat.",
    "Massgebend sind die bei Vertragsabschluss bestätigten Preise und Konditionen.",
    "Die Abrechnung erfolgt grundsätzlich monatlich anhand der tatsächlich erbrachten und abrechenbaren Reinigungsstunden.",
    "Eine Änderung des vereinbarten Stundenpreises bei laufenden regelmässigen Aufträgen wird den Kunden im Voraus mitgeteilt. Der Kunde kann den Auftrag vor Inkrafttreten der Änderung beenden.",
  ]},
  { h: "Neukundenangebot – Erste Stunde gratis", p: [
    "Neukunden erhalten einmalig eine kostenlose Reinigungsstunde bei ihrem ersten bestätigten Reinigungseinsatz.",
    "Die Aktion gilt einmal pro Neukundenhaushalt und kann nicht bar ausbezahlt werden.",
    "Die kostenlose Stunde wird von der ersten Rechnung beziehungsweise vom ersten Einsatz abgezogen.",
    "Weitere Reinigungsstunden werden zum vereinbarten Stundenpreis berechnet.",
    "Das Angebot ist nicht mit anderen Aktionen kombinierbar, sofern nichts anderes ausdrücklich vereinbart wurde.",
  ]},
  { h: "Reinigungstermine und Einsatzplanung", p: [
    "Reinigungstermine werden zwischen MyCleaner und dem Kunden vereinbart.",
    "MyCleaner bemüht sich, bei regelmässigen Reinigungen dieselbe Reinigungskraft einzusetzen.",
    "Bei Krankheit, Ferien oder anderen Verhinderungen kann nach Absprache mit dem Kunden eine geeignete Ersatzperson eingesetzt oder ein Ersatztermin vereinbart werden.",
    "Kann MyCleaner einen vereinbarten Termin nicht wahrnehmen, wird der Kunde möglichst frühzeitig informiert. Nicht erbrachte Reinigungsleistungen werden nicht verrechnet.",
  ]},
  { h: "Pflichten des Kunden", p: [
    "Der Kunde sorgt dafür, dass die vereinbarten Räumlichkeiten zum Reinigungstermin zugänglich sind.",
    "Er informiert MyCleaner vorab über besondere Gegebenheiten, empfindliche Oberflächen, vorhandene Schäden oder sonstige Umstände, die für eine sichere und fachgerechte Reinigung wichtig sind.",
    "Reinigungsmittel und Geräte werden vom Kunden bereitgestellt, soweit nicht ausdrücklich etwas anderes vereinbart wurde.",
    "Der Kunde stellt sicher, dass die bereitgestellten Geräte und Reinigungsmittel sicher und für den vorgesehenen Gebrauch geeignet sind.",
  ]},
  { h: "Terminabsagen und Verschiebungen", p: [
    "Kunden können vereinbarte Reinigungstermine bis 24 Stunden vor dem Termin kostenlos absagen oder verschieben.",
    "Bei kurzfristigeren Absagen kann MyCleaner einen angemessenen, tatsächlich entstandenen und nicht vermeidbaren Ausfall geltend machen, soweit dies rechtlich zulässig ist.",
    "Ersparte Aufwendungen und anderweitig mögliche Einsätze werden berücksichtigt.",
    "Bei Krankheit, Notfällen oder anderen besonderen Umständen bemühen sich beide Parteien um eine faire Lösung.",
    "Gesetzliche Kündigungs- und Rücktrittsrechte bleiben vorbehalten.",
  ]},
  { h: "Regelmässige Reinigungsaufträge und Kündigung", p: [
    "Regelmässige Reinigungsaufträge können wöchentlich, zweiwöchentlich oder in einem individuell vereinbarten Rhythmus durchgeführt werden.",
    "Sofern keine feste Laufzeit ausdrücklich vereinbart wurde, besteht keine Mindestvertragsdauer.",
    "Der Kunde kann regelmässige Reinigungsaufträge jederzeit für die Zukunft kündigen. Bereits verbindlich vereinbarte Einzeltermine unterliegen den Regelungen über Terminabsagen, soweit gesetzlich zulässig.",
    "Die Kündigung kann per E-Mail an info@mycleaner.ch erfolgen.",
    "Zwingende gesetzliche Kündigungsrechte bleiben vorbehalten.",
  ]},
  { h: "Qualität und Beanstandungen", p: [
    "MyCleaner verpflichtet sich zu einer sorgfältigen und fachgerechten Ausführung der vereinbarten Reinigungsarbeiten.",
    "Sollte der Kunde mit der Reinigung nicht zufrieden sein, wird er gebeten, die Beanstandung möglichst innerhalb von 48 Stunden nach dem Einsatz mitzuteilen.",
    "Berechtigte und nachvollziehbare Mängel werden nach Möglichkeit durch eine kostenlose Nachreinigung behoben.",
    "Die genannte Meldefrist stellt keine Ausschlussfrist für gesetzliche Ansprüche dar.",
  ]},
  { h: "Schäden und Haftung", p: [
    "MyCleaner haftet für Schäden, soweit diese nach den gesetzlichen Bestimmungen von MyCleaner oder zurechenbaren Hilfspersonen verursacht wurden.",
    "Schäden sind möglichst zeitnah nach ihrer Entdeckung mitzuteilen und nach Möglichkeit zu dokumentieren.",
    "Für Schäden, die ausschliesslich auf bereits bestehende Mängel, ungeeignete vom Kunden bereitgestellte Reinigungsmittel oder unzutreffende Informationen des Kunden zurückzuführen sind, haftet MyCleaner nur im gesetzlich vorgesehenen Umfang.",
    "Eine Haftung für vorsätzlich oder grobfahrlässig verursachte Schäden wird nicht ausgeschlossen.",
    "Gesetzlich zwingende Haftungsbestimmungen bleiben uneingeschränkt vorbehalten.",
  ]},
  { h: "Versicherung", p: [
    "MyCleaner sorgt für die gesetzlich erforderlichen Versicherungen im Rahmen des tatsächlich bestehenden Beschäftigungs- und Geschäftsmodells.",
    "Aussagen über einen darüber hinausgehenden Versicherungsschutz gelten nur, soweit die entsprechende Versicherungsdeckung tatsächlich besteht.",
  ]},
  { h: "Rechnungsstellung und Zahlung", p: [
    "Die Rechnungsstellung erfolgt grundsätzlich am Monatsende.",
    "Rechnungen sind innerhalb von 14 Tagen nach Erhalt zu bezahlen, sofern keine andere Zahlungsfrist vereinbart wurde.",
    "Die verfügbaren Zahlungsmöglichkeiten werden dem Kunden bei der Rechnungsstellung mitgeteilt.",
    "Bei Zahlungsverzug gelten die gesetzlichen Bestimmungen des Schweizer Obligationenrechts.",
    "Allfällige zusätzliche Inkassokosten können nur im rechtlich zulässigen Umfang geltend gemacht werden.",
  ]},
  { h: "Datenschutz und Vertraulichkeit", p: [
    "MyCleaner behandelt personenbezogene Daten und Informationen über Kunden und deren Haushalte vertraulich.",
    "Personendaten werden insbesondere zur Bearbeitung von Anfragen, Organisation von Reinigungseinsätzen, Kundenbetreuung und Rechnungsstellung verarbeitet.",
    "Soweit für die Auftragsdurchführung erforderlich, können relevante Informationen an eingesetzte Reinigungskräfte weitergegeben werden.",
    "Weitere Informationen zur Datenbearbeitung, Aufbewahrung und zu den Rechten betroffener Personen ergeben sich aus der separaten Datenschutzerklärung auf der Website.",
    "Es gelten die anwendbaren schweizerischen Datenschutzbestimmungen.",
  ]},
  { h: "Änderungen der AGB", p: [
    "MyCleaner kann diese AGB für zukünftige Vertragsabschlüsse ändern.",
    "Für bestehende Verträge gelten grundsätzlich die bei Vertragsabschluss vereinbarten Bedingungen.",
    "Änderungen bestehender Vertragsverhältnisse bedürfen einer entsprechenden Vereinbarung, soweit das Gesetz nichts anderes vorsieht.",
  ]},
  { h: "Anwendbares Recht und Gerichtsstand", p: [
    "Es gilt schweizerisches Recht.",
    "Für Streitigkeiten gelten die gesetzlichen Gerichtsstandsbestimmungen. Zwingende Gerichtsstände, insbesondere bei Konsumentenverträgen, bleiben vorbehalten.",
  ]},
  { h: "Kontakt", p: [
    "Bei Fragen, Beanstandungen oder Anliegen können sich Kunden an folgende Kontaktadresse wenden:",
    ADDRESS,
  ]},
];

export default function Agb() {
  return (
    <LegalPage pageKey="agb" title="Allgemeine Geschäftsbedingungen (AGB)" updated="30. Oktober 2026"
      intro="MyCleaner Hofer – Reinigungsdienstleistungen"
      seoDesc="AGB von MyCleaner Hofer: Preise, Neukundenangebot, Absagen bis 24 Std. kostenlos, jederzeit kündbar."
      sections={SECTIONS} />
  );
}
